<div class="form-header">
  <span *ngIf="edited && (edited.id && edited.id > 0)">Edit</span>
  <span *ngIf="edited && (!edited.id || edited.id === -1)">Add</span>
  service level
</div>

<form [formGroup]="serviceLevelForm" (ngSubmit)="onSubmitForm()" *ngIf="initialized">
  <div class="dialog-container">
    <div class="tabs">
      <button [disabled]="editingChecklistTemplate || dirtyAppointmentTemplate" type="button" mat-button class="body-standard-tab" [ngClass]="{selected: selectedTab == 'general'}"
        (click)="selectTab('general')"><span class="text">
          Service Info
        </span>
        <div class="dot"></div>
      </button>
      <button [disabled]="dirtyServiceLevel || dirtyAppointmentTemplate" type="button" mat-button class="body-standard-tab"
        [ngClass]="{selected: selectedTab == 'checklistTemplates'}" (click)="selectTab('checklistTemplates')"><span
          class="text">
          Checklist Templates
        </span>
        <div class="dot"></div>
      </button>
      <button [disabled]="dirtyServiceLevel || editingChecklistTemplate" type="button" mat-button class="body-standard-tab"
        [ngClass]="{selected: selectedTab == 'appointmentTemplates'}"
        (click)="selectTab('appointmentTemplates')"><span class="text">
          Appointment Templates
        </span>
        <div class="dot"></div>
      </button>

    </div>
    <div class="fields" *ngIf="selectedTab === 'general'">
      <div class="field" required>
        <mat-form-field>
          <mat-label>Service level name</mat-label>
          <input matInput (keypress)="checkServiceLevelDirty()" formControlName="name" maxlength="50" name="name">
        </mat-form-field>
      </div>
      <div class="services-container">
        <div class="two-thirds-field" required>
          <mat-form-field appearance="fill">
            <mat-label>Services</mat-label>
            <input matInput formControlName="service" maxlength="50" name="service">
          </mat-form-field>

        </div>
        <button class="mid-dialog-button" mat-flat-button color="primary" type="button"
        [disabled]="!hasValidServiceToAdd()" (click)="addService()">Add</button>
      </div>
      <div class="services-list">
        <div class="list-item" *ngFor="let service of getServices()">
          <div>{{service.name}}</div>
          <button *ngIf="numberOfFamilies === 0" class="delete-button" (click)="deleteService(service)" mat-icon-button>
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>
 
    </div>



    <div class="templates-list" *ngIf="selectedTab === 'appointmentTemplates'">
      <div class="field" *ngIf="!dirtyAppointmentTemplate">
      <mat-form-field>
        <mat-label>Appointment Template</mat-label>
        <mat-select name="selectedTemplate" (selectionChange)="onTemplateSelected()"  formControlName="selectedTemplate">
          <mat-option *ngFor="let t of appointmentTemplates" [value]="t">{{t.description}}</mat-option>
        </mat-select>

      </mat-form-field>

      <button (click)="createNewTemplate(true)" class="checklist-add-button" mat-icon-button >
        <mat-icon>add</mat-icon>
      </button>    
    </div>
      <div class="fields" *ngIf="dirtyAppointmentTemplate">  
        <div class="edit-panel">
          <div class="field" required>
            <mat-form-field appearance="fill">
              <mat-label>Description</mat-label>
              <input matInput formControlName="description" maxlength="125" name="description">
            </mat-form-field>
          </div>
          <div class="half-field" required>
            <mat-form-field>
              <mat-label>Checklist Template</mat-label>
              <mat-select name="checklistTemplate" formControlName="checklistTemplate">
                <mat-option *ngFor="let ct of checklistTemplates" [value]="ct">{{ct.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="half-field" required>
            <mat-form-field>
              <mat-label>Services</mat-label>
              <mat-select multiple name="templateServices" formControlName="templateServices">
                <mat-option *ngFor="let s of getServices()" [value]="s">{{s.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="half-field" required>
            <mat-form-field appearance="fill">
              <mat-label>Frequency (every)</mat-label>
              <input matInput type="number" formControlName="frequencyNum" max="100" min="0" name="frequencyNum">
            </mat-form-field>
          </div>
          <div class="half-field" required>
            <mat-form-field>
              <mat-label>Frequency Unit</mat-label>
              <mat-select name="frequencyUnit" formControlName="frequencyUnit">
                <mat-option *ngFor="let unit of timeUnits" [value]="unit">{{unit}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="half-field" required>
            <mat-form-field appearance="fill">
              <mat-label>Duration (for)</mat-label>
              <input matInput type="number" formControlName="durationNum" max="100" min="0" name="durationNum">
            </mat-form-field>
          </div>
          <div class="half-field" required>
            <mat-form-field>
              <mat-label>Duration Unit</mat-label>
              <mat-select name="durationUnit" formControlName="durationUnit">
                <mat-option *ngFor="let unit of timeUnits" [value]="unit">{{unit}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- <div class="edit-panel-buttons">
            <button class="edit-panel-button" mat-raised-button color="secondary" type="button"
              (click)="createNewTemplate()">New</button>
            <button class="edit-panel-button" mat-raised-button color="secondary" type="button"
              [disabled]="!hasCompleteTemplate()" (click)="saveTemplate()">Save</button>
            <button class="edit-panel-button" mat-raised-button color="secondary" type="button"
              [disabled]="!hasCompleteTemplate()" (click)="deleteTemplate()">Delete</button>
          </div> -->

        </div>
      </div>
    </div>

  <div class="" *ngIf="selectedTab === 'checklistTemplates'">
    <div class="notes" *ngIf="editingChecklistTemplate">Checklist templates are saved at the provider level and can be used in any service level.</div>
    <div class="field" *ngIf="!editingChecklistTemplate" >
      <mat-form-field>
        <mat-label>Checklist Template</mat-label>
        <mat-select name="checklistTemplate" (selectionChange)="editChecklistTemplate(false, false)"  formControlName="editedChecklistTemplate">
          <mat-option *ngFor="let ct of editableChecklistTemplates" [value]="ct">{{ct.name}}</mat-option>
        </mat-select>

      </mat-form-field>
      <button (click)="editChecklistTemplate(false, true)" class="checklist-add-button" mat-icon-button >
        <mat-icon>add</mat-icon>
      </button>
    </div>
    

    <div class=" fields"  *ngIf="editingChecklistTemplate">
    <div class="field" required>
      <mat-form-field>
        <mat-label>Checklist template name</mat-label>
        <input matInput  formControlName="cltName" maxlength="50" name="cltName">
      </mat-form-field>
    </div>
    <div class="field" required>
      <mat-form-field>
        <mat-label>Add a description</mat-label>
        <input matInput  formControlName="cltDescription" maxlength="255" name="cltDescription">
      </mat-form-field>
    </div>

    <div class="item-edit-panel">
      <div class="notes"> Items </div>
      <div class="field"  *ngIf="!editingChecklistItem">
        <mat-form-field>
          <mat-label>Select an item</mat-label>
          <mat-select (selectionChange)="onItemSelected()" name="checklistTemplate"  formControlName="selectedItem">
            <mat-option *ngFor="let cti of items" [value]="cti">{{cti.item}}</mat-option>
          </mat-select>
  
        </mat-form-field>
      </div>
      <mat-tab-group *ngIf="editingChecklistItem">
        <mat-tab label="General info"> 

          <div class="field" required *ngIf="editingChecklistItem">
            <mat-form-field appearance="fill">
              <mat-label>Item</mat-label>
              <input matInput formControlName="item" maxlength="50" name="item">
            </mat-form-field>
          </div>
         
          <div class="field" required *ngIf="editingChecklistItem">
            <mat-form-field>
              <mat-label>Service</mat-label>
              <mat-select name="cltService" formControlName="cltService">
                <mat-option *ngFor="let r of serviceLevel.services" [value]="r">{{r.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="field-row">
            <div class="third-field" required *ngIf="editingChecklistItem">
              <div class="slide-toggle-adj">
                <mat-slide-toggle formControlName="required">
                  <span class="adjust-more">Required?</span>
                </mat-slide-toggle>
              </div>  
            </div>
            <div class="third-field" required *ngIf="editingChecklistItem">
              <mat-form-field appearance="fill">
                <mat-label>Required By Appt. #</mat-label>
                <input matInput formControlName="requiredByAppNum" maxlength="2" type="number" name="requiredByAppNum">
              </mat-form-field>
            </div>
          </div>
          </mat-tab>
          <mat-tab label="Instructions &amp; Content"> 
            <div class="field"  *ngIf="editingChecklistItem">
              <mat-form-field>
                <mat-label>Add instructions</mat-label>
                <input matInput  formControlName="instructions" maxlength="512" name="instructions">
              </mat-form-field>
            </div>
            <div class="field"  *ngIf="editingChecklistItem">
              <mat-form-field>
                <mat-label>Associated content</mat-label>
                <mat-select  multiple name="itemContent"  formControlName="itemContent">
                  <mat-option *ngFor="let c of contentList" [value]="c.contentIdentifier">{{c.contentName}} ({{c.contentType}})</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </mat-tab>
        </mat-tab-group>
      
      <div class="edit-panel-buttons" >
        <button class="edit-panel-button" mat-raised-button color="secondary" type="button"
          (click)="createNewItem()">New</button>
        <button class="edit-panel-button" mat-raised-button color="secondary" type="button"
          [disabled]="!hasCompleteItem()" (click)="saveItem()">Save</button>
        <button class="edit-panel-button" mat-raised-button color="secondary" type="button"
          (click)="cancelItem()">Cancel</button>
        <button class="edit-panel-button" mat-raised-button color="secondary" type="button"
          [disabled]="!hasCompleteItem()" (click)="deleteItem()">Delete</button>
      </div>

    </div>
   
  </div>
  </div>
  </div>





  <div class="button-container">
    <button class="dialog-button" *ngIf="!editingChecklistTemplate && !dirtyAppointmentTemplate" [disabled]="isFormInValid()" type="submit" mat-flat-button
      color="primary">Save Service Level</button>
      
      <button *ngIf="editingChecklistTemplate  && !dirtyAppointmentTemplate" class="dialog-button" [disabled]="isCLTFormInValid()" type="submit" mat-flat-button
      color="primary">Save Checklist Template</button>  

      <button *ngIf="dirtyAppointmentTemplate" class="dialog-button" [disabled]="!hasCompleteTemplate()" type="submit" mat-flat-button
      color="primary">Save Appointment Template</button>  

      <button class="dialog-button"  *ngIf="dirtyAppointmentTemplate" [disabled]="!getSelectedAppointmentTemplate()" (click)="deleteAppointmentTemplate(true)"  type="button" color="primary" mat-flat-button >
        Delete
      </button>
    <button class="dialog-button" mat-flat-button color="primary" type="button" (click)="close()">Cancel</button>
  </div>


</form>